import { jsx as e } from "react/jsx-runtime";
import { chakra as a } from "@chakra-ui/react";
import { useDatePickerContext as u, useDatePickerStyle as l } from "../DatePicker.context.es.js";
const h = () => {
  const { data: n, propGetters: o, mode: s, updateDirty: i } = u(), r = l(), [{ days: d }] = n.calendars;
  return /* @__PURE__ */ e(a.div, { __css: r.days, children: d.map((t) => {
    const c = o.dayButton(t, {
      onClick() {
        s === "single" && i({ day: !0 });
      }
    });
    return /* @__PURE__ */ e(
      a.button,
      {
        __css: r.day,
        "data-active": t.selected ? "true" : void 0,
        "data-current": t.inCurrentMonth,
        "data-disabled": t.disabled ? "true" : void 0,
        "data-now": t.now ? "true" : void 0,
        "data-range": t.range,
        ...c,
        children: /* @__PURE__ */ e(a.span, { children: t.day })
      },
      t.$date.toString()
    );
  }) });
};
export {
  h as DatePickerDays
};
//# sourceMappingURL=DatePickerDays.es.js.map
